import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_ClientDischargeSummary = ({ itemsRef, showErrorFor }) => {

  return (
    <form id='LSS_ClientDischargeSummary' className='file-pdf-document'>
      <div className='file-template'>
        <table>
          <tr>
            <td className='w-250'><span className='eleHeader'>Date of admission:</span></td>
            <td className='w-250'><span className='eleHeader'>Date of the last service:</span></td>
            <td className='w-250'><span className='eleHeader'>Date of discharge:</span></td>
        </tr>
        <tr>
            <td className='w-250'>
              <input type="date" id="dt1" name="dt1" className='add-only' />
            </td>
            <td className='w-250'>
              <input type="date" id="dt2" name="dt2" className='add-only' />
            </td>
            <td className='w-250'>
              <input type="date" id="dt3" name="dt3" className='add-only' />
            </td>
          </tr>
        </table>
        <p className='w-750'>
          <span className='eleHeader'>Summary of service:</span>
          <textarea id="txtSummaryservice" name="txtSummaryservice" className='add-only'></textarea>
        </p>
         <p className='w-750'>
          <span className='eleHeader'>Recommendations and transition plan:</span>
          <textarea id="txtTransitionPlan" name="txtTransitionPlan" className='add-only'></textarea>
        </p>
        <p className='w-750'>
          <span className='eleHeader'>Medications:</span>
          <textarea id="txtMedications" name="txtMedications" className='add-only'></textarea>
        </p>
         <table>
          <tr>
            <td className='w-750'><span className='eleHeader'>Client terminated:</span></td>
      </tr>
      <tr>
            <td className='w-250'>
              <input type="checkbox" id="cbClientTerminated_1" name="cbClientTerminated_1" className='add-only' value="ClientTerminated_1" />Agency
            </td>

            <td className='w-100'  >
              <input type="checkbox" id="cbClientTerminated_2" name="cbClientTerminated_2" className='add-only' value="ClientTerminated_2" />Program:
            </td>
            <td className='w-250'>
              <input type="text" id="txtClientTerminated" name="cbClientTerminated" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-250' >
              <input type="checkbox" id="cbClientTerminated_3" name="cbClientTerminated_3" className='add-only' value="ClientTerminated_3" />Planned
            </td>
            <td className='w-500'>
              <input type="checkbox" id="cbClientTerminated_4" name="cbClientTerminated_4" className='add-only' value="ClientTerminated_4" />Planned - not initiated by LifeSolutions South
            </td>
        </tr>
        <tr>
            <td className='w-250'>
              <input type="checkbox" id="cbClientTerminated_5" name="cbClientTerminated_5" className='add-only' value="ClientTerminated_5" />Not planned
            </td>
            <td className='w-500'>
              <input type="checkbox" id="cbClientTerminated_6" name="cbClientTerminated_6" className='add-only' value="ClientTerminated_6" />Not planned - not initiated by Life Solutions South
            </td>
        </tr>
        <tr>
            <td className='w-750'><span className='eleHeader'>Outcome: </span></td>
        </tr>
        <tr>
            <td className='w-250'>
              <input type="checkbox" id="cbOutcome_1" name="cbOutcome_1" className='add-only' value="Outcome_1" />Successful
            </td>
            <td className='w-250'>
              <input type="checkbox" id="cbOutcome_2" name="cbOutcome_2" className='add-only' value="cbOutcome_2" />Neutral
            </td>
            <td className='w-250'>
              <input type="checkbox" id="cbOutcome_3" name="cbOutcome_3" className='add-only' value="cbOutcome_3" />Not successful
            </td>
        </tr>
        <tr>
            <td className='w-750'><span className='eleHeader'>Discharge type: </span></td>
        </tr>
        <tr>
            <td className='w-250'>
              <input type="checkbox" id="cbDischarge_1" name="cbDischarge_1" className='add-only' value="Discharge_1" />Client rejects/refusal
            </td>
             <td className='w-250'>
              <input type="checkbox" id="Discharge_2" name="Discharge_2" className='add-only' value="Discharge_2" />Client adopted/foster care
            </td>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_3" name="Discharge_3" className='add-only' value="Discharge_3" />Client died
            </td>
          </tr>
          <tr>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_4" name="Discharge_4" className='add-only' value="Discharge_4" />Client incarcerated
            </td>
            <td className='w-250'>
              <input type="checkbox" id="cbDischarge_5" name="cbDischarge_5" className='add-only' value="Discharge_5" />Client moved
            </td>
             <td className='w-250'>
              <input type="checkbox" id="Discharge_6" name="Discharge_6" className='add-only' value="Discharge_6" />Client reached age of maturity
            </td>
          </tr>
          <tr>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_7" name="Discharge_7" className='add-only' value="Discharge_7" />Client needs services not provided by Life Solutions South
            </td>
            <td className='w-250'>
              <input type="checkbox" id="cbDischarge_8" name="cbDischarge_8" className='add-only' value="Discharge_8" />Funder/referral source removed client
            </td>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_9" name="Discharge_9" className='add-only' value="Discharge_9" />Court ordered - delinquency/ unruly
            </td>
          </tr>
          <tr>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_10" name="Discharge_10" className='add-only' value="Discharge_10" />Goals met
            </td>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_11" name="Discharge_11" className='add-only' value="Discharge_11" />Court ordered -general
            </td>
            <td className='w-250'>
              <input type="checkbox" id="cbDischarge_12" name="cbDischarge_12" className='add-only' value="Discharge_12" />Medical reasons
            </td>
          </tr>
          <tr>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_13" name="Discharge_13" className='add-only' value="Discharge_13" />No contact with client
            </td>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_14" name="Discharge_14" className='add-only' value="Discharge_14" />Service contract completed
            </td>
            <td className='w-250'>
              <input type="checkbox" id="Discharge_15" name="Discharge_15" className='add-only' value="Discharge_15" />Transferred case to Intensive service
            </td>
          </tr>
          <tr>
            <td className='w-750'><span className='eleHeader'>Client notified the right to appeal: </span></td>
          </tr>
          <tr>
            <td className='w-250'>
              <input type="radio" id="rbClientNotified_Yes" name="ClientNotified" className='add-only' value="Yes" /> Yes&nbsp;
            </td>
            <td className='w-250'>
              <input type="radio" id="rbClientNotified_No" name="ClientNotified" className='add-only' value="No" /> No &nbsp;
            </td>
          </tr>
        </table>
        <p className='w-750'>
          <span className='eleHeader'>Comments:</span>
          <textarea id="txtComments" name="txtComments" className='add-only'></textarea>
        </p>
      </div>
    </form>





  )
}




       
        
